import React from 'react';
import { LoadedPage } from '~/components/jsx-helpers/loader-page';
import { ContentBlocks } from './blocks/ContentBlock';
import './flex-page.scss';
function FlexPageBody({ data }) {
    return React.createElement(ContentBlocks, { data: data.body });
}
export default function FlexPage({ data }) {
    return React.createElement("main", { className: "flex-page page" },
        React.createElement(LoadedPage, { data: data, Child: FlexPageBody, doDocumentSetup: true, noCamelCase: true, props: {} }));
}
